import React from 'react';
import { ChoiceResult } from '@/customTypes/chatStory';
import PopupContainer from '@components/commons/popup/container/PopupContainer';
import ChoiceStatistics from '@/components/storyCommon/popup/statistics/ChoiceStatistics';

interface IChoiceStatisticsPopup {
  choiceStatistics: {
    choiceResult: ChoiceResult;
    selectedIndex: number;
    isReplay: boolean;
    choiceImageUrls?: string[];
  };
  onClose: () => void;
}

const ChoiceStatisticsPopup = ({
  choiceStatistics,
  onClose,
}: IChoiceStatisticsPopup) => {
  return (
    <PopupContainer onClose={onClose}>
      <ChoiceStatistics
        choiceStatistics={choiceStatistics}
        onClosePopup={onClose}
      />
    </PopupContainer>
  );
};

export default ChoiceStatisticsPopup;
